import { lazy } from 'react';

const Cascader = lazy(() => import('./Cascader'));

export { Cascader };
